import { css, Interpolation, Theme } from '@emotion/react'
import { buttonClasses } from '@mui/material'
import { pickersLayoutClasses } from '@mui/x-date-pickers'

export const wrapper: (fullWidth?: boolean) => Interpolation<Theme> = (fullWidth) =>
  css`
    width: ${fullWidth ? '100%' : '263px'};
  `

export const labelWrapper: Interpolation<Theme> = (theme) => css`
  width: 100%;
  margin: 0;
  align-items: initial;
  gap: 10px;

  & > .MuiTypography-root {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: ${theme.typographyColors.typographyThree};
  }
`

type Size = 'small' | 'medium' | 'large'

const BUTTON_SIZES: Record<Size, number> = {
  small: 38,
  medium: 42,
  large: 48,
}

export const baseButton: (state: { open?: boolean; error?: boolean; size?: Size }) => Interpolation<Theme> =
  ({ open, error, size }) =>
  (theme) =>
    css`
      width: 100%;
      height: ${BUTTON_SIZES[size ?? 'large']}px;
      background: ${theme.backgrounds.backgroundFour};
      border: 1px solid ${open ? theme.colors.blue : error ? theme.colors.red : theme.backgrounds.backgroundOne};
      box-shadow: ${theme.boxShadows.small};
      border-radius: 14px;
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      display: flex;
      color: ${theme.typographyColors.typographyTwo};

      &:focus {
        border: 1px solid ${theme.colors.blue};
      }

      &:disabled {
        color: ${error ? theme.colors.red : theme.typographyColors.typographyThree};
      }

      span {
        width: 100%;
        text-align: left;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding-left: 14px;
        padding-right: 8px;
      }

      .placeholder {
        color: ${theme.typographyColors.typographyThree};
      }
    `

export const adornmentIcon = (theme: Theme) => css`
  margin-left: ${theme.spacing(1.25)};

  & + span {
    padding-left: ${theme.spacing(1)};
  }
`

export const clearIcon = (theme: Theme) => css`
  * {
    stroke: ${theme.colors.typographyThree};
  }
`

export const popper: Interpolation<Theme> = (theme) =>
  css`
    z-index: 2;
    box-sizing: border-box;
    background: ${theme.backgrounds.backgroundFour};
    border: 1px solid ${theme.backgrounds.backgroundOne};
    box-shadow: ${theme.boxShadows.medium};
    border-radius: 16px;
    max-width: calc(100% - 10px);
    overflow: hidden;

    .${pickersLayoutClasses.root} {
      padding: 8px;
      overflow: auto;
    }

    .${buttonClasses.root} {
      height: auto;
    }
  `
